module.exports = __webpack_public_path__ + "img/living.bac0443e.gif";